<script>


export default {
  name: "DirtyFieldsStateMixIn",
  computed: {},
  data: () => ({
    unSavedChanges: false,
    storeName: null,
  }),
  methods: {
    findDirtyItem(item) {
      return this.$store.state[this.storeName].dirtyFieldItems.find(dirtyItem => item.id === dirtyItem.id)
    },
    addDirtyRow(items, field, type = null) {
      Object.values(items).forEach(item => this.addDirty(item, field, type))
    },
    addDirty(item, field, optionalKey = null) {
      let dirtyItem = this.findDirtyItem(item)
      if (dirtyItem) {
        if (!(dirtyItem.fields.includes(field))) {
          this.$store.dispatch(`${this.storeName}/addDirtyField`, {dirtyItem, field})
        }
      } else {
        dirtyItem = {id: item.id, fields: [field], type: optionalKey}
        this.$store.dispatch(`${this.storeName}/addDirtyFieldItem`, dirtyItem)
      }
      this.unSavedChanges = true
    },
    getDirtyClass(item, field) {
      let dirtyItem = this.findDirtyItem(item)
      return dirtyItem && dirtyItem.fields.includes(field) ? 'border-bottom-orange' : 'border-bottom-blank'
    },
    setUnsavedChanges() {
      this.unSavedChanges = true
    }
  },

}
</script>

<style scoped>

</style>